import { render, staticRenderFns } from "./CopyToClipboardComponent.vue?vue&type=template&id=b5a58232&scoped=true&"
import script from "./CopyToClipboardComponent.vue?vue&type=script&lang=js&"
export * from "./CopyToClipboardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a58232",
  null
  
)

export default component.exports